import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeVi from '@angular/common/locales/vi';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotifierModule } from 'angular-notifier';
import { DitagisAuthModule } from 'ditagis-auth';
import { LibModule } from 'lib';
import '../../../../mapconfig';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { SharedMaterialModule } from './shared/material.module';
import { UrlServiceConvertingInterceptor } from './shared/url-service-converting.interceptor';

registerLocaleData(localeVi, 'en-US');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    LayoutModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedMaterialModule,
    HttpClientModule,
    NotifierModule,
    DitagisAuthModule.forRoot({
      apiUrl: environment.apiUrl
    }),
    LibModule.forRoot({
      apiUrl: environment.apiUrl,
      map: environment.map
    })
  ],
  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UrlServiceConvertingInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  exports: [AppComponent],
})
export class AppModule { }
